"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildTransaction = void 0;
var typhonjs_1 = require("@stricahq/typhonjs");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var logic_1 = require("./logic");
var networks_1 = require("./networks");
var buildSubAccounts_1 = require("./buildSubAccounts");
function getTyphonInputFromUtxo(utxo) {
    var address = typhonjs_1.utils.getAddressFromHex(utxo.address);
    if (address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS) {
        address.paymentCredential.bipPath = utxo.paymentCredential.path;
    }
    return {
        txId: utxo.hash,
        index: utxo.index,
        amount: new bignumber_js_1["default"](utxo.amount),
        tokens: utxo.tokens,
        address: address
    };
}
var buildSendTokenTransaction = function (_a) {
    var a = _a.a, t = _a.t, tokenAccount = _a.tokenAccount, typhonTx = _a.typhonTx, receiverAddress = _a.receiverAddress, changeAddress = _a.changeAddress;
    return __awaiter(void 0, void 0, void 0, function () {
        var cardanoResources, assetId, _b, policyId, assetName, transactionAmount, tokensToSend, tokenUtxos, otherUtxos, sortedTokenUtxo, sortedOtherUtxos, totalAddedTokenAmount, requiredMinAdaForTokens, i, u, sendingToken, i, u;
        return __generator(this, function (_c) {
            cardanoResources = a.cardanoResources;
            assetId = (0, buildSubAccounts_1.decodeTokenCurrencyId)(tokenAccount.token.id).assetId;
            _b = (0, buildSubAccounts_1.decodeTokenAssetId)(assetId), policyId = _b.policyId, assetName = _b.assetName;
            transactionAmount = t.useAllAmount ? tokenAccount.balance : t.amount;
            tokensToSend = [
                {
                    policyId: policyId,
                    assetName: assetName,
                    amount: transactionAmount
                },
            ];
            tokenUtxos = [];
            otherUtxos = [];
            cardanoResources.utxos.forEach(function (u) {
                if (u.tokens.some(function (t) { return (0, buildSubAccounts_1.getTokenAssetId)(t) === assetId; })) {
                    tokenUtxos.push(u);
                }
                else {
                    otherUtxos.push(u);
                }
            });
            sortedTokenUtxo = tokenUtxos.sort(function (a, b) {
                var sendingTokenA = a.tokens.find(function (t) { return (0, buildSubAccounts_1.getTokenAssetId)(t) === assetId; });
                var sendingTokenB = b.tokens.find(function (t) { return (0, buildSubAccounts_1.getTokenAssetId)(t) === assetId; });
                var diff = sendingTokenB.amount.minus(sendingTokenA.amount);
                return diff.eq(0) ? 0 : diff.lt(0) ? -1 : 1;
            });
            sortedOtherUtxos = otherUtxos.sort(function (a, b) {
                var diff = b.amount.minus(a.amount);
                return diff.eq(0) ? 0 : diff.lt(0) ? -1 : 1;
            });
            totalAddedTokenAmount = new bignumber_js_1["default"](0);
            requiredMinAdaForTokens = typhonjs_1.utils.calculateMinUtxoAmount(tokensToSend, new bignumber_js_1["default"](cardanoResources.protocolParams.lovelacePerUtxoWord));
            // Add enough utxo to cover token amount
            for (i = 0; i < sortedTokenUtxo.length; i++) {
                u = sortedTokenUtxo[i];
                sendingToken = u.tokens.find(function (t) { return (0, buildSubAccounts_1.getTokenAssetId)(t) === assetId; });
                typhonTx.addInput(getTyphonInputFromUtxo(u));
                totalAddedTokenAmount.plus(sendingToken.amount);
                if (totalAddedTokenAmount.gte(transactionAmount))
                    break;
            }
            // Add enough utxos to cover the transaction fees
            for (i = 0; i < sortedOtherUtxos.length; i++) {
                u = sortedOtherUtxos[i];
                if (typhonTx.getInputAmount().ada.gte(requiredMinAdaForTokens.plus(5e6))) {
                    break;
                }
                typhonTx.addInput(getTyphonInputFromUtxo(u));
            }
            typhonTx.addOutput({
                address: receiverAddress,
                amount: requiredMinAdaForTokens,
                tokens: tokensToSend
            });
            return [2 /*return*/, typhonTx.prepareTransaction({
                    inputs: [],
                    changeAddress: changeAddress
                })];
        });
    });
};
var buildSendAdaTransaction = function (_a) {
    var a = _a.a, t = _a.t, typhonTx = _a.typhonTx, receiverAddress = _a.receiverAddress, changeAddress = _a.changeAddress;
    return __awaiter(void 0, void 0, void 0, function () {
        var cardanoResources, protocolParams, tokenBalance, minAmountToSpendTokens, sortedUtxos, transactionInputs, usedUtxoAdaAmount, requiredInputAmount, i, utxo, transactionInput;
        return __generator(this, function (_b) {
            cardanoResources = a.cardanoResources;
            protocolParams = cardanoResources.protocolParams;
            if (t.useAllAmount) {
                // add all utxo as input
                cardanoResources.utxos.forEach(function (u) {
                    return typhonTx.addInput(getTyphonInputFromUtxo(u));
                });
                tokenBalance = (0, logic_1.mergeTokens)(cardanoResources.utxos.map(function (u) { return u.tokens; }).flat());
                // if account holds any tokens then add it to changeAddress,
                // with minimum required ADA to spend those tokens
                if (tokenBalance.length) {
                    minAmountToSpendTokens = typhonjs_1.utils.calculateMinUtxoAmount(tokenBalance, new bignumber_js_1["default"](protocolParams.lovelacePerUtxoWord), false);
                    typhonTx.addOutput({
                        address: changeAddress,
                        amount: minAmountToSpendTokens,
                        tokens: tokenBalance
                    });
                }
                return [2 /*return*/, typhonTx.prepareTransaction({
                        inputs: [],
                        changeAddress: receiverAddress
                    })];
            }
            sortedUtxos = cardanoResources.utxos.sort(function (a, b) {
                var diff = b.amount.minus(a.amount);
                return diff.eq(0) ? 0 : diff.lt(0) ? -1 : 1;
            });
            transactionInputs = [];
            usedUtxoAdaAmount = new bignumber_js_1["default"](0);
            requiredInputAmount = t.amount.plus(5e6);
            for (i = 0; i < sortedUtxos.length && usedUtxoAdaAmount.lte(requiredInputAmount); i++) {
                utxo = sortedUtxos[i];
                transactionInput = getTyphonInputFromUtxo(utxo);
                transactionInputs.push(transactionInput);
                usedUtxoAdaAmount.plus(transactionInput.amount);
            }
            typhonTx.addOutput({
                address: receiverAddress,
                amount: t.amount,
                tokens: []
            });
            return [2 /*return*/, typhonTx.prepareTransaction({
                    inputs: transactionInputs,
                    changeAddress: changeAddress
                })];
        });
    });
};
/**
 *
 * @param {CardanoAccount} a
 * @param {Transaction} t
 *
 * @returns {TyphonTransaction}
 */
var buildTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var cardanoResources, protocolParams, typhonTx, ttl, metadata, networkParams, receiverAddress, unusedInternalCred, changeAddress, tokenAccount;
    return __generator(this, function (_a) {
        cardanoResources = a.cardanoResources;
        protocolParams = cardanoResources.protocolParams;
        typhonTx = new typhonjs_1.Transaction({
            protocolParams: {
                minFeeA: new bignumber_js_1["default"](protocolParams.minFeeA),
                minFeeB: new bignumber_js_1["default"](protocolParams.minFeeB),
                stakeKeyDeposit: new bignumber_js_1["default"](protocolParams.stakeKeyDeposit),
                lovelacePerUtxoWord: new bignumber_js_1["default"](protocolParams.lovelacePerUtxoWord),
                collateralPercent: new bignumber_js_1["default"](protocolParams.collateralPercent),
                priceSteps: new bignumber_js_1["default"](protocolParams.priceSteps),
                priceMem: new bignumber_js_1["default"](protocolParams.priceMem),
                languageView: protocolParams.languageView
            }
        });
        ttl = (0, logic_1.getTTL)(a.currency.id);
        typhonTx.setTTL(ttl);
        metadata = [];
        if (t.memo) {
            metadata.push({
                label: 674,
                data: new Map([["msg", [t.memo]]])
            });
        }
        if (metadata.length) {
            typhonTx.setAuxiliaryData({ metadata: metadata });
        }
        networkParams = (0, networks_1.getNetworkParameters)(a.currency.id);
        receiverAddress = typhonjs_1.utils.getAddressFromBech32(t.recipient);
        unusedInternalCred = cardanoResources.internalCredentials.find(function (cred) { return !cred.isUsed; });
        changeAddress = (0, logic_1.getBaseAddress)({
            networkId: networkParams.networkId,
            paymentCred: unusedInternalCred,
            stakeCred: (0, logic_1.getAccountStakeCredential)(a.xpub, a.index)
        });
        if (t.subAccountId) {
            tokenAccount = a.subAccounts
                ? a.subAccounts.find(function (a) {
                    return a.id === t.subAccountId;
                })
                : undefined;
            if (!tokenAccount || tokenAccount.type !== "TokenAccount") {
                throw new Error("TokenAccount not found");
            }
            return [2 /*return*/, buildSendTokenTransaction({
                    a: a,
                    t: t,
                    tokenAccount: tokenAccount,
                    typhonTx: typhonTx,
                    receiverAddress: receiverAddress,
                    changeAddress: changeAddress
                })];
        }
        return [2 /*return*/, buildSendAdaTransaction({
                a: a,
                t: t,
                typhonTx: typhonTx,
                receiverAddress: receiverAddress,
                changeAddress: changeAddress
            })];
    });
}); };
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map